module.exports = __webpack_public_path__ + "static/img/jun_star.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/jun_star.jpg
// module id = +eej
// module chunks = 0